import Axios from 'axios'

export const generateTokenApi = (payload, handleError) =>
  Axios.post(process.env.REACT_APP_BASE_URL + 'public/api/v1/auth/token', payload, {
    headers: {
      'Content-Type': 'application/json',
      'X-APP-TOKEN': 'TWTpknTux7PzuqDh6qLJQPXNvRT3an7B'
    }
  })
    .then((res) => res)

    // .catch(error => handleError(error.response))
    .catch(error => error.response)

export const postLoginApi = (jwtToken, payload) =>
  Axios.post(process.env.REACT_APP_BASE_URL + 'public/api/v1/staff/authenticate', payload, {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
      'Content-Type': 'application/json'
    }
  })
    .then((res) => res)
    .catch(error => error.response)